import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDPaper,
  FDPrimaryActionButton,
  FDStack,
  FDTitleText,
  FDBodyText,
} from '@facet-wealth/design';
import { DialogActions, DialogContent, DialogTitle } from 'Views/Page/Content/Modal/Components';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';
import { dataAttrs } from 'Helpers/Testing';

const Layout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  const stackProps = isMobile ? { direction: 'column' } : { direction: 'row', wrap: true };

  return (
    <React.Fragment>
      <DialogTitle value={resource.attr('title')} />
      <DialogContent>
        <FDStack direction="column" spacing={2} overflow="hidden">
          <MetaControlField attr="description" />
          <FDStack spacing={1} {...stackProps} overflow="auto">
            {resource.attr('liabilities').resources().list().map(el => (
              <FDPaper appearance="flat" color="info" padding={2} minWidth="240px" width="240px" minHeight="150px" height="150px">
                <FDStack direction="column" justifyContent="center" height="100%">
                  <FDTitleText value={el.attr('primaryText')} />
                  <FDBodyText value={el.attr('secondaryText')} />
                </FDStack>
              </FDPaper>
            ))}
          </FDStack>
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDPrimaryActionButton
          {...dataAttrs('continue-btn', resource)}
          loading={saving}
          onClick={onSubmit}
          label="Continue →"
        />
      </DialogActions>
    </React.Fragment>
  );
};

export default Layout;
